function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M 42.9375,0 0,16.15625 l 17.15625,6.5 16.40625,-6.28125 1.75,1.875 -14.8125,5.65625 22.9375,8.6875 41.9375,-16.4375 z",
  id: "rect2995"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M 14.3982,25.51444 43.18755,35.8685 71.47182,25.2619 73.9972,39.1515 c 0,0 -19.67267,4.76337 -30.30458,14.64721 C 31.29295,44.74218 12.37789,38.89896 12.37789,38.89896 Z",
  id: "rect2998"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m 41.96875,10.4375 -33.625,12.5 C 7.6055,22.19374 6.52963,21.71875 5.3125,21.71875 c -2.23157,0 -4.03125,1.57863 -4.03125,3.53125 0,1.69931 1.36114,3.1291 3.1875,3.46875 l -2.4375,18 h 7.8125 C 8.02917,38.40828 8.30961,35.45471 6.8125,28.5625 c 1.3814,-0.48674 2.36758,-1.64331 2.5,-3 l 33.625,-12.5 z",
  id: "path3001"
});

var SvgGraduate = function SvgGraduate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 53.79871,
    width: 85.375,
    id: "svg5",
    viewBox: "0 0 85.375 53.79871",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGraduate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/graduate.152a195f.svg";
export { ForwardRef as ReactComponent };